import React from 'react';

const AdminBlog = () => {
  return (
    <div>
      <h2>Blog Management</h2>
      <ul style={listStyle}>
        <li>
          <strong>5 Summer Dishes You Must Try</strong> – Published on July 5, 2025
        </li>
        <li>
          <strong>Chef's Tips: How to Plate Like a Pro</strong> – Draft
        </li>
        <li>
          <strong>Top 10 Wines to Pair with Pasta</strong> – Published on June 22, 2025
        </li>
      </ul>
    </div>
  );
};

const listStyle = {
  marginTop: '20px',
  paddingLeft: '20px',
};

export default AdminBlog;
